<template>
  <oceano-default-section :section="section" :menu="menu" section-modifier="steak"
                          class="menu--section-oceano_steak"></oceano-default-section>
</template>

<script lang="ts">
/**
 * Custom component for Oceano steak menu section layout.
 *
 * @author Jasper Howard <jhoward@peppermillcas.com>
 * @version 1.0.1
 * @copyright  Copyright (C) 2023-2025, Peppermill Inc. All rights reserved. Redistribution and use in source and binary forms, with or without modification, are not permitted.
 *
 *    2023-10-05 (1.0.0) (jhoward)
 *      - <OceanoSteakSection> adds a steak layout for Oceano menu sections.
 *
 *  2025-04-08 (1.0.1) (jhoward)
 *    - Replace "menuVersion" prop with "menu" prop in <OceanoSteakSection>.
 *    - Remove "visual_" prefix from class names in <OceanoSteakSection>.
 */

import {defineComponent, PropType} from "vue";
import OceanoDefaultSection from "./OceanoDefaultSection.vue";
import {Menu, MenuSection} from "../defs";

export default defineComponent({
  name: 'OceanoSteakSection',
  components: {OceanoDefaultSection},
  props: {
    section: {
      type: Object as PropType<MenuSection>,
      required: true
    },
    menu: {
      type: Object as PropType<Menu>,
      required: true
    },
  },
})
</script>

<style scoped>
.menu--section-oceano_steak:deep(.menu--item_subgroup) {
  grid-gap: 0.2em;
}

.menu--section-oceano_steak:deep(.menu--section_subgroup_title) {
  font-weight: initial;
  color: #042b49;
  margin: 0 0 0.5em 0;
  font-size: 1.1em;
  font-family: fisherman, serif;
}

.menu--section-oceano_steak:deep(.menu--section_subgroup_title span) {
  position: relative;
  padding-bottom: 0.1em;
}

.menu--section-oceano_steak:deep(.menu--section_subgroup_title span:first-child) {
  left: -1.25em;
  border-bottom: 0.15em solid #042b49;
  padding-left: 1.25em;
}
</style>